let lockCount = 0
const scrollStack: number[] = []

let savedHtml: Partial<CSSStyleDeclaration> | null = null
let savedBody: Partial<CSSStyleDeclaration> | null = null

export function lockScroll() {
  if (typeof window === 'undefined') return

  if (lockCount === 0) {
    const html = document.documentElement
    const body = document.body

    scrollStack.push(window.scrollY || window.pageYOffset || 0)

    savedHtml = {
      overflow: html.style.overflow,
    }

    savedBody = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
    }

    body.style.position = 'fixed'
    body.style.top = `-${scrollStack[scrollStack.length - 1]}px`
    body.style.left = '0'
    body.style.right = '0'
    body.style.width = '100%'
  }

  lockCount += 1
}

export function unlockScroll() {
  if (typeof window === 'undefined') return
  // Nothing locked: don't touch the body nor scroll (would pop an empty stack and scroll to 0)
  if (lockCount === 0) return

  lockCount -= 1
  if (lockCount !== 0) return

  const html = document.documentElement
  const body = document.body

  html.style.overflow = savedHtml?.overflow ?? ''

  body.style.overflow = savedBody?.overflow ?? ''
  body.style.position = savedBody?.position ?? ''
  body.style.top = savedBody?.top ?? ''
  body.style.left = savedBody?.left ?? ''
  body.style.right = savedBody?.right ?? ''
  body.style.width = savedBody?.width ?? ''

  const lastScroll = scrollStack.pop() ?? 0

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.scrollTo(0, lastScroll)
    })
  })

  savedHtml = null
  savedBody = null
}
